const { MODULE_FREE_LIMIT_SETTING, MODULE_LIMIT_SETTING } = require('../constants/settings');
const { LicenseInterval } = require('../services/prisma/types');

function hasLicenseLimit(limit) {
  return limit != null && limit >= 0;
}

function reachedLicenseLimit(value, limit) {
  return hasLicenseLimit(limit) && value >= limit;
}

function exceededLicenseLimit(value, limit) {
  return hasLicenseLimit(limit) && value > limit;
}

function isModuleFree(module) {
  return module?.level === 1;
}

function isLicenseFree(dataSourceLicense) {
  if (dataSourceLicense) {
    if (dataSourceLicense.license) {
      return isModuleFree(dataSourceLicense.license);
    }
    if (dataSourceLicense.modules?.length > 0) {
      return dataSourceLicense.modules.every(isModuleFree);
    }
  }
  return false;
}

function isLicensesFree(dataSourceLicenses) {
  return dataSourceLicenses?.every(isLicenseFree);
}

function isLicenseTrial(dataSourceLicense) {
  return dataSourceLicense?.interval === LicenseInterval.Trial;
}

function getDataSourceLicenseTitle(dataSourceLicense) {
  const { license, modules } = dataSourceLicense || {};

  if (license) {
    return license.title;
  }

  if (modules?.length > 0) {
    return modules.map(m => m.title).join(', ');
  }

  return null;
}

function getDataSourceLicenseUniqueTitle(dataSourceLicense) {
  const { license, modules } = dataSourceLicense || {};

  if (license) {
    return license.uniqueTitle || license.title;
  }

  if (modules?.length > 0) {
    return modules.map(m => m.uniqueTitle || m.title).join(', ');
  }

  return null;
}

function getModuleLimitSetting(module, level) {
  if (isModuleFree({ level })) {
    return MODULE_FREE_LIMIT_SETTING[module];
  }

  return MODULE_LIMIT_SETTING[module];
}

function hasModuleLicense(dataSourceLicense, module) {
  return dataSourceLicense?.license != null || dataSourceLicense?.modules?.some(m => m.module === module);
}

module.exports = {
  hasLicenseLimit,
  reachedLicenseLimit,
  exceededLicenseLimit,
  isModuleFree,
  isLicenseFree,
  isLicensesFree,
  isLicenseTrial,
  getDataSourceLicenseTitle,
  getDataSourceLicenseUniqueTitle,
  getModuleLimitSetting,
  hasModuleLicense,
};
